import { Component, ojs, app, v, component } from "modular-openscriptjs";
import {
    pageInfo,
    formatThousand,
    scrollToTop,
} from "../../../helpers";
import { PAGES, uc } from "../../../declarations";
import DepositAiCreditForm from "../../Forms/DepositAiCreditForm";
import { $e } from "../../../ojs.events";

const h = app("h");

ojs(DepositAiCreditForm);

export default class AiCreditWallet extends Component {
    balancedFetched = false;

    render(...args) {
        pageInfo(PAGES.AI_CREDITS);
        scrollToTop();

        return h.div(
            { class: "py-5 min-vh-100 mb-5 py-md-5" },
            h.div(
                { class: "container" },
                // Header Section
                h.div(
                    { class: "mb-5 text-center mt-3" },
                    h.div(
                        {
                            class: "d-inline-flex align-items-center gap-2 px-3 py-1 border rounded-pill shadow-sm mb-3 ai-float bg-white",
                        },
                        h.i({ class: "bi bi-stars text-warning fs-5" }),
                        h.span({ class: "fw-bold text-dark" }, "AI Power Hub"),
                    ),
                    h.h1(
                        { class: "fw-bold display-5 mb-3" },
                        h.span({ class: "text-dark" }, "Your AI "),
                        h.span(
                            {
                                style: "background: linear-gradient(to right, #d49a2a, #973e87); -webkit-background-clip: text; -webkit-text-fill-color: transparent;",
                            },
                            "Credits",
                        ),
                    ),
                    h.p(
                        {
                            class: "text-secondary fs-5 mx-auto",
                            style: "max-width: 600px;",
                        },
                        "Your AI assistant for smarter, faster ordering",
                    ),
                ),

                h.div(
                    { class: "row justify-content-center g-4" },
                    // Balance Card
                    h.div(
                        { class: "col-lg-5 col-md-6" },
                        h.div(
                            {
                                class: "card border-0 rounded-4 shadow-lg ai-gradient-bg text-white h-100 overflow-hidden position-relative hover-scale",
                                style: "min-height: 200px;",
                            },
                            // Decorative circles
                            h.div({
                                class: "position-absolute rounded-circle",
                                style: "width: 200px; height: 200px; background: rgba(255,255,255,0.08); top: -40px; right: -40px; filter: blur(5px);",
                            }),
                            h.div({
                                class: "position-absolute rounded-circle",
                                style: "width: 300px; height: 300px; background: rgba(255,255,255,0.05); bottom: -120px; left: -80px; filter: blur(3px);",
                            }),

                            h.div(
                                {
                                    class: "card-body p-4 p-md-4 d-flex flex-column position-relative z-1",
                                },
                                h.div(
                                    {
                                        class: "d-flex justify-content-between align-items-start mb-auto",
                                    },
                                    h.div(
                                        h.h6(
                                            {
                                                class: "text-white opacity-75 fw-semibold text-uppercase mb-3",
                                                style: "font-size: 0.85rem; letter-spacing: 1.5px;",
                                            },
                                            "Available Balance",
                                        ),
                                        v(uc.aiCredit, (wallet) =>
                                            h.h1(
                                                {
                                                    class: "fw-bold mb-0 display-4",
                                                },
                                                formatThousand(
                                                    wallet.value?.balance ?? 0,
                                                ),
                                                h.span(
                                                    {
                                                        class: "fs-5 fw-normal opacity-75 ms-2",
                                                    },
                                                    "Credits",
                                                ),
                                            ),
                                        ),
                                    ),
                                    h.div(
                                        {
                                            class: "glass-panel rounded-circle d-flex align-items-center justify-content-center shadow ai-float",
                                            style: "width: 56px; height: 56px;",
                                        },
                                        h.i({
                                            class: "bi bi-lightning-charge-fill fs-3 text-white",
                                        }),
                                    ),
                                ),
                                h.button(
                                    {
                                        class: "btn btn-light w-100 rounded-pill fw-bold py-3 mt-4 shadow text-primary border-0",
                                        style: "font-size: 1.1rem; transition: all 0.2s; background: white;",
                                        onmouseover:
                                            "this.style.transform='scale(1.02)';",
                                        onmouseout:
                                            "this.style.transform='scale(1)';",
                                        onclick: h.func("fireEvent", $e.aiCredit.needs.deposit),
                                    },
                                    h.i({
                                        class: "bi bi-plus-circle-fill me-2",
                                    }),
                                    "Buy AI Credits",
                                ),
                            ),
                        ),
                    ),

                    // Info/Features Column
                    h.div(
                        { class: "col-lg-5 col-md-6" },
                        h.div(
                            { class: "d-flex flex-column gap-3 h-100" },

                            // Feature 1
                            h.div(
                                {
                                    class: "card border border-light rounded-4 shadow-sm feature-card h-100",
                                },
                                h.div(
                                    {
                                        class: "card-body p-4 d-flex align-items-center gap-4",
                                    },
                                    h.div(
                                        {
                                            class: "feature-icon-wrapper flex-shrink-0",
                                        },
                                        h.i({ class: "bi bi-telephone-fill fs-4" }),
                                    ),
                                    h.div(
                                        h.h6(
                                            { class: "fw-bold mb-1 text-dark" },
                                            "Voice Call to Order",
                                        ),
                                        h.p(
                                            {
                                                class: "text-muted mb-0 small fw-medium",
                                            },
                                            "Chat with our AI in real time to place an order.",
                                        ),
                                    ),
                                ),
                            ),

                            // Feature 2
                            h.div(
                                {
                                    class: "card border border-light rounded-4 shadow-sm feature-card h-100",
                                },
                                h.div(
                                    {
                                        class: "card-body p-4 d-flex align-items-center gap-4",
                                    },
                                    h.div(
                                        {
                                            class: "feature-icon-wrapper flex-shrink-0",
                                        },
                                        h.i({
                                            class: "bi bi-plus-circle-fill fs-4",
                                        }),
                                    ),
                                    h.div(
                                        h.h6(
                                            { class: "fw-bold mb-1 text-dark" },
                                            "Add Your Own Products",
                                        ),
                                        h.p(
                                            {
                                                class: "text-muted mb-0 small fw-medium",
                                            },
                                            "Add custom products to your listings using your AI credits instantly.",
                                        ),
                                    ),
                                ),
                            ),

                            // Feature 3
                            h.div(
                                {
                                    class: "card border border-light rounded-4 shadow-sm feature-card h-100",
                                },
                                h.div(
                                    {
                                        class: "card-body p-4 d-flex align-items-center gap-4",
                                    },
                                    h.div(
                                        {
                                            class: "feature-icon-wrapper flex-shrink-0",
                                        },
                                        h.i({ class: "bi bi-camera-fill fs-4" }),
                                    ),
                                    h.div(
                                        h.h6(
                                            { class: "fw-bold mb-1 text-dark" },
                                            "Image to Product",
                                        ),
                                        h.p(
                                            {
                                                class: "text-muted mb-0 small fw-medium",
                                            },
                                            "Take a picture of a product and we will automatically extract the product details and add it to your cart.",
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    ),
                ),
            ),
            ...args,
        );
    }

    $_mounted(componentId) {
        let cmp = component(componentId);

        if (cmp && !cmp.balancedFetched) {
            app("broker").send($e.aiCredit.needs.balance);
            cmp.balancedFetched = true;
        }
    }
}

ojs(AiCreditWallet);
